export default __webpack_public_path__ + "2829400fa370775dfc4ddffa9dcc2211.svg";